import { useEffect, useCallback } from 'react';

import { useAppStore } from '@/store';
import { useToast } from './useToast';

import type { IAppStore } from '@/store';

const selector = (store: IAppStore) => ({
  localNotification: store.localNotification,
  setLocalNotification: store.setLocalNotification,
  setScreen: store.setScreen,
});

/**
 * Hook that watches for local notifications and shows a toast
 * when user is not on the result/loading screen.
 * Clicking the CTA navigates to the result view.
 */
const useLocalNotification = () => {
  const { toast, showToast, hideToast } = useToast({ actionDuration: 6000 });

  const { localNotification, setLocalNotification, setScreen } =
    useAppStore(selector);

  const handleViewResult = useCallback(() => {
    hideToast();
    setScreen('result');
    setLocalNotification(null);
  }, [hideToast, setScreen, setLocalNotification]);

  useEffect(() => {
    if (localNotification) {
      showToast({
        message: 'Your creation is ready!',
        type: 'success',
        action: {
          label: 'View',
          onClick: handleViewResult,
        },
      });

      // Clear the notification from store after showing
      setLocalNotification(null);
    }
  }, [localNotification, showToast, handleViewResult, setLocalNotification]);

  return { toast, hideToast };
};

export { useLocalNotification };
